
import config from '@/assets/config.json';
import api from '../../api/index';
const state = {}
const mutations = {

}
const getters = {

}
const actions = {
  BatchBtn({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.put(`${config.newHttps.api}/admin/restricted/area/button`,opt
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  NotDdeliverAdd({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/admin/restricted/area/add`,opt
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  NotDdeliverAddress({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.put(`${config.newHttps.api}/admin/restricted/area/edit`,opt
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  ImportAddress({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/admin/restricted/area/list/into`,{params:opt}
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  NotDdeliverCause({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.put(`${config.newHttps.api}/admin/restricted/area/edit/reason`,opt
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  NotDdeliverDelet({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.delete(`${config.newHttps.api}/admin/restricted/area/del`,{params:opt}
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  ExpressList({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.logisticsHttps.api}/api/Adm_Company/Drop_LogisticsCompany`,{params:opt}
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  NotDdeliverList({
    rootState,
    commit
  },opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/admin/restricted/area/list`,{params:opt}
      // {
      //   headers: {
      //     Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
      //   },
      // }
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}